import { watch, ref, reactive, nextTick } from "vue";
export default {
  props: ["questionInfo"],
  setup(props) {
    let audioStatus = ref(0);
    let questionAudioStatus = reactive([0, 0, 0, 0, 0, 0, 0, 0, 0]);
    let taskNo = ref(0);
    //处理题目
    function clearText(text) {
      let getStr = text;
      for (let i = 0;; i++) {
        if (getStr.indexOf("{{") == -1) break;
        getStr = getStr.substring(0, getStr.indexOf("{{")) + getStr.substr(getStr.indexOf("}}") + 2);
      }
      return getStr.replace(/&nbsp;/g, "");
    }
    function play(id, no = null) {
      audioStatus.value = 0;
      questionAudioStatus.value = 0;
      document.getElementById("question_audio_oral").pause();
      document.getElementById("audio_oral").pause();
      for (let i = 0; i < 10; i++) {
        questionAudioStatus[i] = 0;
      }
      if (no != null) {
        taskNo.value = no;
        document.getElementById("question_audio_oral").load();
        nextTick(() => {
          document.getElementById(id).play();
        });
      } else {
        document.getElementById(id).play();
      }
    }
    function pause(id) {
      document.getElementById(id).pause();
    }
    //更换题目
    watch(() => props.questionInfo, () => {
      audioStatus.value = 0;
      for (let i = 0; i < 10; i++) {
        questionAudioStatus[i] = 0;
      }
      document.getElementById("question_audio_oral").load();
      document.getElementById("audio_oral").load();
      document.getElementsByClassName("question")[0].scrollTop = 0;
    });
    return {
      taskNo,
      clearText,
      audioStatus,
      questionAudioStatus,
      play,
      pause
    };
  }
};